<div *ngIf="!loading" style="text-align: center;">
    <img src="/assets/images/loading4.gif" />
</div>
